"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7246],{

/***/ 27246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93451);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34209);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37678);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79758);











var getDatasetForUrl = function() {
    var host = location.hostname;
    if (host.match("localhost") || host.match("development")) return "dev";
    else return "staging";
};
/**
 * Given a timestamp, or using the current time if one's not provided,
 * parse into separate date and time parts.
 */ function getDefaultDateAndTime(timestampInMilliseconds) {
    var baseDateAndTime = timestampInMilliseconds ? new Date(Number.parseInt(timestampInMilliseconds)) : new Date();
    return {
        date: "".concat(baseDateAndTime.getFullYear(), "-").concat((baseDateAndTime.getMonth() + 1 + "").padStart(2, "0"), "-").concat((baseDateAndTime.getDate() + "").padStart(2, "0")),
        time: baseDateAndTime.toTimeString().substring(0, 5)
    };
}
var openContentComponentInSanity = function(e) {
    e.preventDefault();
    var elem = e.target.closest("[data-id]");
    var data = elem === null || elem === void 0 ? void 0 : elem.dataset;
    if ((data === null || data === void 0 ? void 0 : data.id) && data.type) {
        window.open("https://studio.xetic.puma.com/".concat(getDatasetForUrl(), "/desk/") + encodeURIComponent("__edit__".concat(data.id, ",type=").concat(data.type)));
    }
};
var ContentManagementToolbox = function() {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(!!router.query.draft), 2), open = ref1[0], setOpen = ref1[1];
    var form = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useForm */ .cI)();
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useAllCustomerGroupsQuery */ .y5I)({
        pause: utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .isServer */ .sk
    }), 1), customerGroupsResult = ref2[0];
    var customerGroups = (ref = customerGroupsResult.data) === null || ref === void 0 ? void 0 : ref.allCustomerGroups;
    var defaultViewAt = getDefaultDateAndTime(router.query.viewAt);
    var callback = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(event) {
        if (event.data === "PagePreviewPostMessage") {
            router.push({
                query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, router.query), {
                    draft: Date.now()
                })
            });
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router.query
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        window.addEventListener("message", callback, false);
        return function() {
            return window.removeEventListener("message", callback);
        };
    }, [
        callback,
        router.query
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var cb = openContentComponentInSanity;
        if (open) document.addEventListener("contextmenu", cb);
        else document.removeEventListener("contextmenu", cb);
        return function() {
            return document.removeEventListener("contextmenu", cb);
        };
    }, [
        open
    ]);
    var handleSubmit = function(data) {
        var selectedDate = data.date && data.time ? new Date("".concat(data.date, "T").concat(data.time)) : undefined;
        var query = Object.entries((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, router.query), {
            customerGroups: data.customerGroup ? [
                data.customerGroup
            ] : undefined,
            draft: Date.now(),
            global: data.global,
            src: data.sourceCode ? data.sourceCode : undefined,
            viewAt: selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.getTime()
        })).reduce(function(acc, param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
            if (v !== undefined) acc[k] = v;
            return acc;
        }, {});
        router.push({
            query: query
        });
    };
    var clearForm = function(e) {
        e.preventDefault();
        form.reset();
        router.push({
            pathname: router.asPath.split("?")[0]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: form.handleSubmit(handleSubmit),
                noValidate: true,
                className: (0,twind__WEBPACK_IMPORTED_MODULE_10__.tw)("fixed z-40 w-full max-w-80 bottom-14 right-8 p-6 bg-white border shadow-2xl rounded-xl space-y-3"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        className: "block space-y-2 uppercase font-bold text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "View Page On"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                "data-test-id": "content-management-toolbox",
                                className: "flex border divide-x rounded-sm",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        ref: form.register(),
                                        name: "date",
                                        defaultValue: defaultViewAt.date,
                                        className: "w-full p-2",
                                        type: "date"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        ref: form.register(),
                                        name: "time",
                                        defaultValue: defaultViewAt.time,
                                        className: "w-full p-2",
                                        type: "time",
                                        step: "60"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        className: "block space-y-2 uppercase font-bold text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Customer Group"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full border p-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                    ref: form.register(),
                                    name: "customerGroup",
                                    className: "w-full",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                            value: "",
                                            children: "Select Customer Group"
                                        }),
                                        customerGroups ? customerGroups.map(function(group) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                selected: router.query.customerGroups === group,
                                                children: group
                                            }, group);
                                        }) : "Loading..."
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        className: "block space-y-2 uppercase font-bold text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Source Code"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                ref: form.register(),
                                defaultValue: router.query.src,
                                name: "sourceCode",
                                className: "block w-full border p-2",
                                type: "text"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        className: "block space-y-2 uppercase font-bold text-sm cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Global Content"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full border p-3 flex items-center space-x-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        className: "cursor-pointer",
                                        type: "checkbox",
                                        name: "global",
                                        defaultChecked: router.query.global === "true",
                                        ref: form.register()
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-normal normal-case leading-none block mb-0.5",
                                        children: "See page from a global context"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex space-x-2 !mt-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                type: "submit",
                                label: "View",
                                dataTestId: "content-management-submit-btn"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                onClick: clearForm,
                                variant: "secondary",
                                label: "Clear",
                                dataTestId: "content-management-clear-btn"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: function() {
                    return setOpen(!open);
                },
                "data-test-id": "content-management-dialog",
                "aria-label": "Content management dialog",
                className: "fixed z-50 bottom-10 right-5 bg-black text-white flex rounded-full m-0 p-2",
                type: "button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    enableBackground: "new 0 0 24 24",
                    height: "24px",
                    viewBox: "0 0 24 24",
                    width: "24px",
                    fill: "currentColor",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                fill: "none",
                                height: "24",
                                width: "24"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        height: "8.48",
                                        transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.8717 17.6255)",
                                        width: "3",
                                        x: "16.34",
                                        y: "12.87"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M17.5,10c1.93,0,3.5-1.57,3.5-3.5c0-0.58-0.16-1.12-0.41-1.6l-2.7,2.7L16.4,6.11l2.7-2.7C18.62,3.16,18.08,3,17.5,3 C15.57,3,14,4.57,14,6.5c0,0.41,0.08,0.8,0.21,1.16l-1.85,1.85l-1.78-1.78l0.71-0.71L9.88,5.61L12,3.49 c-1.17-1.17-3.07-1.17-4.24,0L4.22,7.03l1.41,1.41H2.81L2.1,9.15l3.54,3.54l0.71-0.71V9.15l1.41,1.41l0.71-0.71l1.78,1.78 l-7.41,7.41l2.12,2.12L16.34,9.79C16.7,9.92,17.09,10,17.5,10z"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ContentManagementToolbox);


/***/ })

}]);